import React, { useEffect } from 'react';
import './ProductModal.scss';
import { createPortal } from 'react-dom';
import { useContentful } from '../contentful/ContentContext';
import { Document } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

type ProductModalProps = {
  product: {
    name: string;
    price: number;
    richDescription: Document;
    numberOfItemsInStock?: number;
    category?: string;
    mainImage: {
      fields: {
        file: {
          url: string;
        };
      };
      title: string;
    };
  };
  onClose: () => void;
};

const ProductModal = ({ product, onClose }: ProductModalProps) => {
  const { getUiText } = useContentful();

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return createPortal(
    <div className={'modalOverlay'} onClick={onClose}>
      <div className={'modalContent'} onClick={(e) => e.stopPropagation()}>
        <div className={'imageWrapper'}>
          <img
            className={'image'}
            src={`https://${product?.mainImage?.fields?.file?.url}`}
            alt={product?.mainImage?.title}
          />
          <button className={'closeButton'} onClick={onClose}>
            {getUiText('UI.Close')}
          </button>
        </div>
        <div className={'modalInfo'}>
          <div className={'modalLeft'}>
            {product?.category && (
              <p className={'productCategory'}>{product.category}</p>
            )}
            <h2 className={'productName'}>{product?.name}</h2>
          </div>
          <div className={'modalRight'}>
            <p className={'productPrice'}>{product?.price} kr</p>
          </div>
        </div>
        <div className={'productDescription'}>
          {product?.richDescription &&
            documentToReactComponents(product.richDescription)}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProductModal;
